import { Link } from 'react-router-dom';

export default function ArticleSection() {
  return (
    <section id="articles" className="py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-4 tracking-wide">
            LEARN MORE
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            Kakobuy Spreadsheet <span className="text-primary-500">Resources</span>
          </h2>
          <p className="mt-4 text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Dive deeper into guides, tips, and in-depth articles about getting the most out of your Kakobuy Spreadsheet experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Link
            to="/kakobuy-spreadsheet-guide"
            className="group block p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
          >
            <div className="w-full h-48 rounded-xl overflow-hidden mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20home%20office%20with%20a%20large%20monitor%20displaying%20colorful%20spreadsheet%20data%20visualizations%2C%20ergonomic%20wooden%20desk%2C%20indoor%20monstera%20plant%20in%20terracotta%20pot%2C%20steaming%20latte%20in%20ceramic%20mug%2C%20morning%20sunlight%20through%20sheer%20curtains%2C%20organized%20productive%20workspace%2C%20modern%20minimal%20decor%20with%20warm%20wood%20accents%2C%20lifestyle%20tech%20photography&width=800&height=480&seq=article-card-2026-n4&orientation=landscape"
                alt="Kakobuy Spreadsheet Complete Guide"
                title="Kakobuy Spreadsheet Complete Guide - Learn everything about Kakobuy Spreadsheet"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <span className="text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full">Complete Guide</span>
            <h3 className="mt-3 text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200">
              Kakobuy Spreadsheet: The Complete 2026 Guide to Smarter Product Discovery
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              Everything you need to know about using Kakobuy Spreadsheet effectively - from beginner basics to advanced product discovery strategies.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm font-medium text-primary-600">
              Read More
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <Link
            to="/kakobuy-vs-cssbuy-spreadsheet"
            className="group block p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-300 transition-all duration-300 cursor-pointer"
          >
            <div className="w-full h-48 rounded-xl overflow-hidden mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20split%20screen%20composition%20showing%20two%20distinct%20product%20collections%20on%20separate%20surfaces%2C%20left%20side%20features%20modern%20sneakers%20and%20streetwear%20on%20concrete%20texture%2C%20right%20side%20shows%20classic%20leather%20goods%20on%20warm%20wood%2C%20dramatic%20side%20lighting%20creating%20depth%2C%20editorial%20fashion%20comparison%20concept%2C%20rich%20contrasting%20textures&width=800&height=480&seq=article-card-2026-n6&orientation=landscape"
                alt="Kakobuy vs CSSBuy Spreadsheet comparison"
                title="Kakobuy vs CSSBuy Spreadsheet - Full comparison guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <span className="text-xs font-medium text-accent-600 bg-accent-100 px-3 py-1 rounded-full">Comparison</span>
            <h3 className="mt-3 text-lg font-heading font-bold text-foreground-950 group-hover:text-accent-600 transition-colors duration-200">
              Kakobuy vs CSSBuy Spreadsheet: Which One Should You Choose?
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              A detailed side-by-side comparison of the top shopping spreadsheets to help you choose the right tool for your needs.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm font-medium text-accent-600">
              Read More
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>

          <Link
            to="/category-guide-shoes"
            className="group block p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-secondary-300 transition-all duration-300 cursor-pointer"
          >
            <div className="w-full h-48 rounded-xl overflow-hidden mb-5">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20product%20photography%20of%20trending%20fashion%20items%20laid%20out%20on%20a%20light%20oak%20table%2C%20designer%20sneakers%20next%20to%20a%20linen%20shirt%20and%20leather%20tote%20bag%2C%20soft%20afternoon%20light%20from%20a%20nearby%20window%2C%20lifestyle%20editorial%20composition%2C%20warm%20neutral%20palette%20with%20pops%20of%20muted%20sage%20green%2C%20relaxed%20aspirational%20aesthetic&width=800&height=480&seq=article-card-2026-n5&orientation=landscape"
                alt="Shoes Category Guide"
                title="Kakobuy Spreadsheet Shoes Category Guide"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <span className="text-xs font-medium text-secondary-600 bg-secondary-100 px-3 py-1 rounded-full">Category Guide</span>
            <h3 className="mt-3 text-lg font-heading font-bold text-foreground-950 group-hover:text-secondary-600 transition-colors duration-200">
              Ultimate Kakobuy Spreadsheet Shoes Guide: Find Your Perfect Pair
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
              Deep dive into the most popular category - sneakers, running shoes, casual footwear, and more organized for easy discovery.
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm font-medium text-secondary-600">
              Read More
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}